import { render } from "./PasswordChange.vue?vue&type=template&id=5cd2a2e9&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=5cd2a2e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cd2a2e9"

export default script